enum LoginVariant {
  Local = 'LOCAL',
  Google = 'GOOGLE',
}

export default LoginVariant;
